import React from 'react';
import { motion } from 'framer-motion';
const treatments = [{
  title: 'NAD+ Skin Rejuvenation',
  description: 'Advanced cellular therapy that targets skin aging at its source, promoting collagen production and cellular repair.',
  image: 'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80'
}, {
  title: 'Cellular Face Therapy',
  description: 'Combines NAD+ with targeted peptides for comprehensive facial rejuvenation and radiance.',
  image: 'https://images.unsplash.com/photo-1516975080664-ed2fc6a32937?w=800&q=80'
}, {
  title: 'Body Optimization',
  description: 'Full-body NAD+ treatment designed to enhance skin elasticity, tone, and overall vitality.',
  image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800&q=80'
}];
export function MedicalAesthetics() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className="w-full min-h-screen bg-white" data-id="element-260">
      {/* Hero Section */}
      <section className="px-6 py-32 md:py-40 bg-zinc-50 text-zinc-950" data-id="element-261">
        <div className="max-w-4xl mx-auto text-center" data-id="element-262">
          <motion.p className="text-sm tracking-[0.3em] uppercase mb-8 text-zinc-600" initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-263">
            Medical Aesthetics
          </motion.p>
          <motion.h1 className="text-5xl md:text-7xl font-serif mb-8 leading-tight" style={{
          fontFamily: 'Playfair Display, serif'
        }} initial={{
          y: 30,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-264">
            Cellular Beauty
          </motion.h1>
          <motion.p className="text-lg md:text-xl text-zinc-600 leading-relaxed max-w-2xl mx-auto" initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-265">
            Where advanced cellular science meets aesthetic medicine. True
            beauty radiates from within, at the cellular level.
          </motion.p>
        </div>
      </section>

      {/* Treatments */}
      <section className="px-6 py-32 md:py-40 bg-white" data-id="element-266">
        <div className="max-w-7xl mx-auto space-y-24" data-id="element-267">
          {treatments.map((treatment, index) => <div key={index} className={`grid grid-cols-1 md:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'md:grid-flow-dense' : ''}`} data-id="element-268">
              <div className={index % 2 === 1 ? 'md:col-start-2' : ''} data-id="element-269">
                <h2 className="text-4xl md:text-5xl font-serif mb-6 text-zinc-950" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-270">
                  {treatment.title}
                </h2>
                <p className="text-lg text-zinc-600 leading-relaxed" data-id="element-271">
                  {treatment.description}
                </p>
              </div>
              <div className={`aspect-[4/5] bg-zinc-200 overflow-hidden ${index % 2 === 1 ? 'md:col-start-1 md:row-start-1' : ''}`} data-id="element-272">
                <img src={treatment.image} alt={treatment.title} className="w-full h-full object-cover" data-id="element-273" />
              </div>
            </div>)}
        </div>
      </section>

      {/* Philosophy */}
      <section className="px-6 py-32 md:py-40 bg-zinc-50" data-id="element-274">
        <div className="max-w-4xl mx-auto text-center" data-id="element-275">
          <p className="text-sm tracking-[0.3em] uppercase mb-8 text-zinc-600" data-id="element-276">
            Our Approach
          </p>
          <h2 className="text-4xl md:text-5xl font-serif mb-8 text-zinc-950" style={{
          fontFamily: 'Playfair Display, serif'
        }} data-id="element-277">
            Beyond Surface Beauty
          </h2>
          <p className="text-lg text-zinc-600 leading-relaxed mb-8" data-id="element-278">
            Traditional aesthetics treat symptoms. We address the root cause. By
            optimizing cellular function with NAD+, we enable your skin to
            regenerate naturally, revealing its inherent radiance.
          </p>
          <p className="text-lg text-zinc-600 leading-relaxed" data-id="element-279">
            The result is not just younger-looking skin, but genuinely
            healthier, more resilient tissue that ages gracefully.
          </p>
        </div>
      </section>
    </motion.div>;
}